<template>
	<div class="partial auth-login">
		<Card>
			<LoginForm class="auth-login__form" :checkout="checkout" />
			<div class="auth-login__message">
				New to Sentencing Pro? <Button class="ml-1" look="flat" :to="{name: 'checkout'}" v-if="!checkout">Join here</Button> <Button look="flat" v-else @click="setLink('register')">Join here</Button>
			</div>
		</Card>
	</div>
</template>

<script>
import { useHead } from '@unhead/vue';
import { useUserStore } from '@/lib/store/user'

import Button from '@/components/Button.vue'
import Card from '@/components/Card.vue'
import LoginForm from '@/components/LoginForm.vue'

export default {
	name: 'PartialAuthLogin',
	components: {
		Button,
		Card,
		LoginForm,
	},
	setup() {
		useHead({
			title: `Login`
		})
		return {
			userStore: useUserStore()
		}
	},
	props: {
		routeLink: true,
		checkout: false,
	},
	methods: {
		setLink() {
			this.userStore.authStep = 'register'
		}
	},
}
</script>

<style scoped lang="scss">
.auth-login {
	max-width: 440px;

	&__message {
		background-color: var(--color--background-light);
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
		font-size: 0.95rem;
		margin-top: 1rem;
		padding: 1rem;
		text-align: center;
	}
}
</style>
